module.exports = __webpack_public_path__ + "img/1-1PGFJ122I7.be83e84c.jpeg";